import React from 'react';
import cx from 'classnames';

const Divider = ({ className }: { className?: string }) => {
  return <div className={cx('bg-gold-50 h-px w-full', className)} />;
};

export default Divider;
